import {
	AirlineStore,
	AirportStore,
	FlightEnrichStore,
} from '@move-frontend/dap';
import { createFlightEnrichers } from './createFlightEnrichers';
import { IEnrichedFlightProps } from '../models/IEnrichedFlight';
import { IFlight } from '../models/IFlight';

export function createFlightEnrichStore(
	airlineStore: AirlineStore,
	airportStore: AirportStore,
) {
	const enrichers = createFlightEnrichers(airlineStore, airportStore);

	return new FlightEnrichStore<IFlight, IEnrichedFlightProps>(
		enrichers.airlineEnricher,
		enrichers.airportEnricher,
	);
}
